import React from 'react';
import { Form, Input, Button,Spin,Select,DatePicker } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined,MailOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

var token= ''
var sacco= ''
var bizuserid= ''

class TargetCreateForm extends React.Component {

  state = {
    staffroleName:'' ,  
    targetdescription:'',
    datarequested:false,
    selectedaccount:'',
    users:[],
    dateone:moment().format(dateFormat).toString(),
    datetwo:moment().format(dateFormat).toString(),

  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
      bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/accounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          users:res.data
        })
      })
  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('date_one', this.state.dateone);
    form_data.append('date_two', this.state.datetwo);

    form_data.append('targettitle', this.state.targettitle);
    form_data.append('target_desc', this.state.targetdescription);
    form_data.append('sacco', sacco);
    form_data.append('target_user', Number(this.state.selectedaccount));
      axios.post(serverconfig.backendserverurl+'/api/targets/',form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => this.setState({datarequested:false})
    ,window.location.reload(false)
    )
    .catch(error => console.log(error))
  
  }

  onBlur=()=> {
    console.log('blur');
  }
  
   onFocus=()=>{
    console.log('focus');
  }
  
  onSearch=(val)=> {
    console.log('search:', val);
  }
 

  render(){
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>

      <h3>Target Create Form</h3>

    <Form
          onFinish={(event) => this.handleFormSubmit(event)}  >

        <FormItem label="Date Range">
          <RangePicker onChange={
              (date, dateString) =>{
                this.setState({ dateone: dateString[0]});
                this.setState({ datetwo: dateString[1]});
              }
          } format={dateFormat} />
      </FormItem>


    <FormItem label="Target user">
        <Select 
        placeholder="User"
        style={{ width: 200 }} 
        value={this.state.selectedaccount} 
        onChange={(val)=>{this.setState({selectedaccount:val})}}
        showSearch
        optionFilterProp="children"
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onSearch={this.onSearch}       
        >
          {this.state.users.map(
            (user)=>{
              if (Number(bizuserid)===Number(user.id)){

              }else{
                return  (
                  <Option value={user.id}>{user.username}</Option>
                )
              }
            }
            
            )}
        </Select>
    </FormItem>

      <FormItem   
      label="Target Title"
      name="targettitle"
      rules={[
        {
          required: true,
          message: 'Please input title',
        },
      ]}      
      >
        <Input name="targettitle"  placeholder="Put a title here." value={this.state.targettitle} onChange={(val)=>{this.setState({targettitle:val.target.value})}} />
      </FormItem>

      <FormItem label="Target description"
        name="description"
        rules={[
          {
            required: true,
            message: 'Please input desc',
          },
        ]}     
      >
          <TextArea
            name="description"
            placeholder="Description here"
            autoSize={{ minRows: 2, maxRows: 6 }}
            onChange={(val)=>{this.setState({targetdescription:val.target.value})}}
            value={this.state.targetdescription}
          />

      </FormItem>
     
      <FormItem>
        <Button  type="primary" htmlType="submit">Create Target</Button>
      </FormItem>
      </Form>
     </div>
      );

    }

  }

}


export default TargetCreateForm;



